import "./SectionHeader.css";

import { Button } from "antd";
import { IoMdAdd } from "react-icons/io";
import { useNavigate } from "react-router-dom";

interface SectionHeaderProps {
  createRoute: string;
  dataLength: number;
}

export const SectionHeader = ({
  createRoute,
  dataLength,
}: SectionHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className="sectionHeaderContainer">
      <div className="left">
        <h2>List</h2>
        <span>{dataLength}</span>
      </div>

      <div className="right">
        <Button
          size="large"
          type="default"
          variant="outlined"
          icon={<IoMdAdd />}
          onClick={() => createRoute && navigate(`/${createRoute}/create`)}
        >
          Create
        </Button>
      </div>
    </header>
  );
};
